import { c as _c } from "react/compiler-runtime";
import { WrenchScrewdriver } from '@byway/icons/src/icons/WrenchScrewdriver';
import { Heading } from '~/components/Heading';
import { Link } from '~/components/Link';
import styles from './DiyOptionBlock.module.css';
import type { DiyOptionBlockProps } from './DiyOptionBlock.types';
const DiyOptionBlock = t0 => {
  const $ = _c(14);
  const {
    data
  } = t0;
  if (!data?.title || !data.description || !data.ctaLabel || !data.ctaHref) {
    return null;
  }
  const {
    title,
    description,
    ctaLabel,
    ctaHref
  } = data;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className={styles.icon} aria-hidden="true"><WrenchScrewdriver decorative={true} size="scale" /></span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Heading level="h2" variant="heading-sm" className={styles.title}>{title}</Heading>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <p className={styles.description}>{description}</p>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className={styles.copy}>{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== ctaHref || $[9] !== ctaLabel) {
    t5 = <Link href={ctaHref} asButton="secondary" target="_self" data-ua-click="diy_option_block_cta">{ctaLabel}</Link>;
    $[8] = ctaHref;
    $[9] = ctaLabel;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className={styles.container} data-test-id="DiyOptionBlock">{t1}{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export { DiyOptionBlock };